module.exports = "data:text/x-markdown;base64,QSBzbWFydCBjb250cmFjdCB1c2VzIGEgZ3VhcmQgbGlicmFyeSB0byBwcm90ZWN0IGl0c2VsZiwgeW91ciBtaXNzaW9uIGlzIHRvIGNyYWNrIHRoZSBsaWJyYXJ5LCBsZXQgYHBhc3NgIGZ1bmN0aW9uIHJldHVybiBgdHJ1ZWAhCgpUaXBzOgoqIEhhY2sgYSBjb250cmFjdCB3aXRob3V0IHNvdXJjZSBjb2RlLgoKR29vZCBsdWNrIGFuZCBoYXZlIGh1biEK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/strongBox.md
// module id = 1407
// module chunks = 0